export const listaInvitados = {
  "hno-carlitos": {
    nombre: "Hno. Carlitos y Abuelita",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    telefono: "+524291098621"
  },
  "hno-daniel-y-esposa": {
    nombre: "Hno. Daniel S. y Hna. Sara",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    telefono: "+524622638331"
  },
  "hno-valle": {
    nombre: "Hno. Valle y Esposa",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    telefono: "+524621331069"
  },
  "francisco-mary-ballon": {
    nombre: "Francisco & Mary Ballón",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    telefono: "+524623418585"
  },
  "ricardo-ballon": {
    nombre: "Ricardo Ballón",
    pases: 1,
    adultos: 1,
    ninos: 0,
    host: "david",
    telefono: "+524623418585"
  },
  "hno-daniel-r-y-esposa": {
    nombre: "Hno. Daniel R y Esposa",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    telefono: "+524621211982"
  },
  "hno-gonzalo-y-esposa": {
    nombre: "Hno. Gonzalo González y esposa",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "david",
    telefono: "+524451028705"
  },
  "familia-mariel": {
    nombre: "Hno. Isaias & Hna. Claudia y Mariel",
    pases: 3,
    adultos: 3,
    ninos: 0,
    host: "david",
    mensaje: "Gracias por tu apoyo y amistad incondicional. ",
    telefono: "+524623342067"
  },
  "jenny-david": {
    nombre: "Jenny & David",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    telefono: "+524296977743"
  },
  "miguel-novia": {
    nombre: "Miguel & Novia",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    telefono: "+524622617952"
  },
  "david-o-y-reny": {
    nombre: "David Osorio & Reny",
    pases: 2,
    adultos: 2,
    ninos: 0,
    host: "david",
    mensaje: "David, gracias por tu amistad y apoyo incondicional. Eres mi hermano y mi amigo, te aprecio mucho, espero en Dios que podamos seguir creciendo juntos y ahora con nuestras esposas.",
    telefono: "+524623386550"
  },
};